module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"projectname-label":"Nom du projet","required-field":"Ce champs est requis"},"de":{"projectname-label":"Name des projket","required-field":"Dieses Feld wird benötigt"}}')
  delete Component.options._Ctor
}
